import React from "react";
import NavBar from "../general/navBar";

const Hero = () => {
  return (
    <section className="hero-offer-section" id="hero-offer">
      <NavBar />
      <article>
        <h1>Nos offres, votre avenir</h1>
        <p>
          Des missions adaptées à vos compétences, à portée de clic.
          <br /> Postulez à l’une de nos offres d’emploi disponibles ci-dessous.
        </p>
      </article>
    </section>
  );
};

export default Hero;
